declare const require: any;

const moduleMap: any = {};

export function loadModule(umdFileName: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {

        if (moduleMap[umdFileName]) {
            resolve(window);
            return;
        }

        const script = document.createElement('script');
        script.src = umdFileName;

        script.onerror = reject;

        script.onload = () => {
            moduleMap[umdFileName] = true;
            resolve(window); // window is the global namespace
        }

        document.body.append(script);
    });
}

export function initExternals(production: boolean) {
    (window as any).ng = {} as any;
    (window as any).ng.core = require('@angular/core');
    (window as any).ng.forms = require('@angular/forms');
    (window as any).ng.common = require('@angular/common');
    (window as any).ng.common.http = require('@angular/common/http');
    (window as any).ng.common.locales = {};
    (window as any).ng.common.locales.pt = require('@angular/common/locales/pt');
    (window as any).ng.router = require('@angular/router');
    (window as any).ng.platformBrowser = require('@angular/platform-browser');
    (window as any).ng.platformBrowser = require('@angular/platform-browser');
    (window as any).ng.animations = require('@angular/animations');
    (window as any).ng.cdk = require('@angular/cdk');
    (window as any).ng.fire = require('@angular/fire');
    (window as any).ng.fire.firestore = require('@angular/fire/firestore');
    (window as any)['@angular/flex-layout'] = require('@angular/flex-layout');
    (window as any).ng.material = require('@angular/material');
    (window as any).ng.material.toolbar = require('@angular/material/toolbar');
    (window as any).ng.material.icon = require('@angular/material/icon');
    (window as any).ng.material.button = require('@angular/material/button');
    (window as any).ng.material.progressBar = require('@angular/material/progress-bar');
    (window as any).ng.material.paginator = require('@angular/material/paginator');
    (window as any).ng.material.progressSpinner = require('@angular/material/progress-spinner');
    (window as any).ng.material.select = require('@angular/material/select');
    (window as any).ng.material.list = require('@angular/material/list');
    (window as any).ng.material.expansion = require('@angular/material/expansion');
    (window as any).ng.material.stepper = require('@angular/material/stepper');
    (window as any).ng.material.checkbox = require('@angular/material/checkbox');
    (window as any).ng.material.sort = require('@angular/material/sort');
    (window as any).ng.material.table = require('@angular/material/table');
    (window as any).ng.material.dialog = require('@angular/material/dialog');
    (window as any).ng.material.tooltip = require('@angular/material/tooltip');
    (window as any).ng.material.formField = require('@angular/material/form-field');
    (window as any).ng.material.input = require('@angular/material/input');
    (window as any).ng.material.card = require('@angular/material/card');
    (window as any).ng.material.divider = require('@angular/material/divider');
    (window as any).ng.material.gridList = require('@angular/material/grid-list');
    (window as any).ng.material.tabs = require('@angular/material/tabs');
    (window as any).ng.material.core = require('@angular/material/core');
    (window as any).ng.material.menu = require('@angular/material/menu');
    (window as any).ng.material.badge = require('@angular/material/badge');
    (window as any).ng.material.chips = require('@angular/material/chips');
    (window as any).ng.material.snackBar = require('@angular/material/snack-bar');
    (window as any).ng.material.sidenav = require('@angular/material/sidenav');
    (window as any).ng.material.datepicker = require('@angular/material/datepicker');
    (window as any).ng.material.radio = require('@angular/material/radio');
    (window as any).ng.material.buttonToggle = require('@angular/material/button-toggle');
    (window as any).ng.material.autocomplete = require('@angular/material/autocomplete');
    (window as any).ng.material.slideToggle = require('@angular/material/slide-toggle');
    (window as any).ng.cdk = require('@angular/cdk');
    (window as any).ng.cdk.dragDrop = require('@angular/cdk/drag-drop');
    (window as any).ng.flexLayout = require('@angular/flex-layout');
    (window as any).ng.flexLayout.flex = require('@angular/flex-layout/flex');
    (window as any).ng.flexLayout.extended = require('@angular/flex-layout/extended');
    (window as any).moment = require('moment');
    (window as any).ng.materialMomentAdapter = require('@angular/material-moment-adapter');
    (window as any)['@ngrx/store'] = require('@ngrx/store');
    (window as any)['@ngrx/effects'] = require('@ngrx/effects');
    (window as any)['@ngrx/entity'] = require('@ngrx/entity');
   (window as any).rxjs = require('rxjs');
   (window as any).rxjs.operators = require('rxjs/operators');




    (window as any)['file-saver'] = require('file-saver');
    (window as any).firebase = require('firebase');
    (window as any).hammerjs = require('hammerjs');
    (window as any).lodash = require('lodash');
    (window as any).moment = require('moment');
    (window as any)['ngx-currency'] = require('ngx-currency');
    (window as any)['ngx-mask'] = require('ngx-mask');
    (window as any)['psc-ng-common'] = require('psc-ng-common');
    (window as any)['psc-ng-dynamic-form'] = require('psc-ng-dynamic-form');
    (window as any)['psc-ng-firebase'] = require('psc-ng-firebase');
    (window as any)['psc-ng-googlemaps'] = require('psc-ng-googlemaps');
    (window as any)['auth-app-lib'] = require('auth-app-lib');
    (window as any)['account-store'] = require('account-store');
    (window as any)['company-store'] = require('company-store');
    (window as any)['subscription-store'] = require('subscription-store');
    (window as any)['plan-subscription-store'] = require('plan-subscription-store');
    (window as any)['menu-store'] = require('menu-store');
    (window as any)['order-store'] = require('order-store');
    (window as any)['chart.js'] = require('chart.js');
    (window as any)['ng2-charts'] = require('ng2-charts');
    (window as any)['ngx-card'] = require('ngx-card');
    (window as any)['firebaseui-angular'] = require('firebaseui-angular');
    (window as any)['firebaseui'] = require('firebaseui');
    (window as any)['angularx-qrcode'] = require('angularx-qrcode');
    (window as any)['client-store'] = require('client-store');
    (window as any)['courier-store'] = require('courier-store');
    (window as any)['cashier-store'] = require('cashier-store');
    (window as any)['ngx-printer'] = require('ngx-printer');
    (window as any)['geofirestore'] = require('geofirestore');
    (window as any)['geofire-common'] = require('geofire-common');
    (window as any)['html2pdf'] = require('html2pdf.js');
    (window as any)['html2pdf'] = require('html2pdf.js');


    if (!production) {
        (window as any).ng.platformBrowserDynamic = require('@angular/platform-browser-dynamic');
        (window as any).ng.compiler = require('@angular/compiler');
    }
}
